import * as React from 'react';
export default function useEvent(callback) {
    const fnRef = React.useRef(null);
    fnRef.current = callback;
    const memoFn = React.useCallback(((...args) => fnRef.current?.(...args)), []);
    return memoFn;
}
//# sourceMappingURL=useEvent.js.map